import type { IContextualMenuRenderItem } from "@fluentui/react/lib/ContextualMenu";

export function defaultKeytipExecute(
  el?: HTMLElement,
  keytipExecute?: (el?: HTMLElement) => void
): void {
  el && el.focus();
  keytipExecute && keytipExecute(el);
}

export function menuItemInMenuOnExecute(
  executeTarget: HTMLElement,
  contextualItem: React.RefObject<IContextualMenuRenderItem>
): void {
  executeTarget.focus();
  //we could potentially remove the 'if part' when we remove V8 code
  if (contextualItem.current) {
    contextualItem.current.openSubMenu();
  } else {
    executeTarget.click();
  }
}

export function itemInMenuOnExecute(
  executeTarget: HTMLElement,
  contextualItem: React.RefObject<IContextualMenuRenderItem>,
  keytipExecute: () => void,
  dismissHostingSurfaceOnExecute?: boolean
): void {
  executeTarget.focus();
  //we could potentially remove the 'if part' when we remove V8 code
  if (contextualItem.current && dismissHostingSurfaceOnExecute !== false) {
    contextualItem.current.dismissMenu(true);
  } else {
    executeTarget.click();
  }
  keytipExecute();
}
